import { h } from 'preact'
import formatDateInLocalTimezone from "../../utils/dateFormatting";
import UserAvatar from "../../User/UserAvatar";

type Props = {
  lastActivity: {
    lastActivityAt: string,
    lastContributor: {
      id: string,
      username: string,
      avatar: string
    }
  }
}

const LastActivityCell = () => {
  return ({ lastActivity } : Props) => {
    if (!lastActivity) {
      return null
    }

    const { lastActivityAt, lastContributor } = lastActivity

    const { id, username, avatar } = lastContributor
    const user = {
      id,
      name: username,
      avatar,
      url: `/member/profile?userid=${id}`
    }
    const date = formatDateInLocalTimezone(lastActivityAt)

    return (
      <div className='overview__table-last-activity'>
        <div className='overview__table-last-activity-date'>{date + ' by '}</div>
        <UserAvatar user={user} openInNewTab style={{ width: '16px', height: '16px' }} />
        <a href={user.url} target='_blank'>{username}</a>
      </div>
    )
  }
}

export default LastActivityCell
